import cloneDeep from "lodash/cloneDeep";
export default (graphComponentRef) => (documentObjectId, attribute) => {
    if (!graphComponentRef.current)
        return undefined;
    const node = graphComponentRef.current.graph.nodes.find(n => n.tag.Id === documentObjectId);
    if (!node || !node.tag)
        return undefined;
    const nodeTag = cloneDeep(node.tag);
    nodeTag.Attributes = [attribute, ...(nodeTag.Attributes || [])];
    node.tag = nodeTag;
    return nodeTag;
};
